import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination from '../../utils/RecordsPagination';

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  tableStyle: {
    padding: 0
  }
};

const AirlineTableStructure = ({classes, airlinesPaymentsData, pageIndex}) => (
  <div
  className={classes.tableResponsive}
  style={{ overflowX: "auto" }}
>
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell>S/No</TableCell>
                <TableCell>Payment Date</TableCell>
                <TableCell>Invoice Number</TableCell>
                <TableCell>Airline Name</TableCell>
                <TableCell>Token Amount (&#8358;)</TableCell>
                <TableCell>Tokens Purchased</TableCell>
                <TableCell>Location</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {airlinesPaymentsData.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell>{pageIndex + key}</TableCell>
                        <TableCell component="th">
                            {appHelpers.formatDateSpecific(
                                item.PaymentDate
                            )}
                        </TableCell>
                        <TableCell>{item.InvoiceNumber}</TableCell>
                        <TableCell>{item.AirlineName}</TableCell>
                        <TableCell>
                            &#8358; {appHelpers.numberWithCommas(item.Amount)}
                        </TableCell>
                        <TableCell>{appHelpers.numberWithCommasOnly(item.Token)}</TableCell>
                        <TableCell>{item.Location}</TableCell>

                    </TableRow>
                );
            })}
        </TableBody>
        <TableFooter>
            {/*<RecordPagination fetchMore={fetchPayments} totalCount={totalPaymentCount} pageSize={pageSize} currentPage={currentPage} target={<AirlinesTable/>}/>*/}
            {/*<TableRow />*/}
        </TableFooter>
    </Table>
</div>

)

class AirlinesPaymentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
        airlinesPaymentsData: false
    };
  }

  handleClickOpen = (airlinesPaymentData) => {
    this.setState({ open: true });
    this.setState({airlinesPaymentData});
  };

  handleClose = () => {
    this.setState({ open: false });
  };


  render() {
    const { classes, airlinesPaymentsData, fetchPayments, totalPaymentCount, pageSize, currentPage,  } = this.props;
    const pageIndex = (pageSize * (currentPage - 1)) + 1;
    return (
      <div>
          <RecordPagination fetchMore={fetchPayments} totalCount={totalPaymentCount} pageSize={pageSize} currentPage={currentPage}
                            target={<AirlineTableStructure classes={classes}
                                                           pageIndex={pageIndex}
                                                           handleClickOpen={this.handleClickOpen}
                                                           airlinesPaymentsData={airlinesPaymentsData}/>}/>
      </div>
    );
  }
}
export default withMobileDialog()(withStyles(styles)(AirlinesPaymentTable));



// WEBPACK FOOTER //
// ./src/views/AirlinePayment/AirlinesTable.jsx